export const GET_ANALYSTS_LIST = 'GET_ANALYSTS_LIST';
export const GET_ANALYSTS_LIST_SUCCESS = 'GET_ANALYSTS_LIST_SUCCESS';
export const GET_ANALYSTS_LIST_FAILURE = 'GET_ANALYSTS_LIST_FAILURE';
export const DELETE_ANALYST = 'DELETE_ANALYST';
export const DELETE_ANALYST_SUCCESS = 'DELETE_ANALYST_SUCCESS';
export const DELETE_ANALYST_FAILURE = 'DELETE_ANALYST_FAILURE';

export const getAnalystsList =()=>{
    return{
        type:GET_ANALYSTS_LIST
    }
}

export const getAnalystsListSuccess =(data)=>{
    return{
        type:GET_ANALYSTS_LIST_SUCCESS,
        data
    }
}

export const getAnalystsListFailure =(data)=>{
    return{
        type:GET_ANALYSTS_LIST_FAILURE,
        data
    }
}

export const deleteAnalyst =(id)=>{
    return{
        type:DELETE_ANALYST,
        id
    }
}

export const deleteAnalystSuccess =(data)=>{
    return{
        type:DELETE_ANALYST_SUCCESS,
        data
    }
}

export const deleteAnalystFailure =(data)=>{
    return{
        type:DELETE_ANALYST_FAILURE,
        data
    }
}
